import request from '@/utils/request'

export const uploadApi = file => {
  var formdata = new FormData()
  formdata.append('file', file)
  return request.post('/cent-data-core/upload/img', formdata, { dataType: 'formData' })
}
export const uploadFileApi = file => {
  var formdata = new FormData()
  formdata.append('file', file)
  return request.post('/cent-data-core/upload/file', formdata, { dataType: 'formData' })
}
// 获取个人信息
export const getUserInfoApi = () => { return request.get('/cent-data-core/personal/get') }
// 获取项目详情
export const getProjectDetailApi = params => { return request.get('/cent-data-core/project/detail', { params: params }) }



// WEBPACK FOOTER //
// ./src/api/common_api.js